import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/**
 * Alshallal badge — HeroUI chip style.
 * All variants use color-mix soft fills so the token pipeline stays clean.
 * Default = brand orange soft. Use `secondary` for the neutral sky-tinted
 * pills you see in the topbar avatar summary, `success` / `warning` /
 * `danger` for status.
 */
const badgeVariants = cva(
  [
    "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5",
    "text-[11px] font-semibold whitespace-nowrap select-none",
    "transition-colors duration-150 focus:outline-none",
  ].join(" "),
  {
    variants: {
      variant: {
        default:
          "bg-[color:var(--brand-orange-soft)] text-[color:var(--brand-orange-soft-fg)]",
        secondary:
          "bg-[color:var(--brand-sky-soft)] text-[color:var(--ink)]",
        success:
          "bg-[color:var(--success-soft)] text-[color:var(--success-soft-fg)]",
        warning:
          "bg-[color:var(--warning-soft)] text-[color:var(--warning-soft-fg)]",
        destructive:
          "bg-[color:var(--danger-soft)] text-[color:var(--danger-soft-fg)]",
        brown:
          "bg-[color:var(--brand-brown-soft)] text-[color:var(--brand-brown-soft-fg)]",
        outline:
          "border border-[color:var(--border-strong)] text-[color:var(--ink)]",
        solid:
          "bg-[color:var(--brand-orange)] text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
